// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2vM_U","header":"ClearentDisclaimer_header__1CVpe","inner":"ClearentDisclaimer_inner__36m0E"};